export var FilterOperation;
(function (FilterOperation) {
    FilterOperation["eq"] = "eq";
    FilterOperation["not_eq"] = "not_eq";
    FilterOperation["nil"] = "nil";
    FilterOperation["not_nil"] = "not_nil";
    FilterOperation["in"] = "in";
    FilterOperation["not_in"] = "not_in";
    FilterOperation["lt"] = "lt";
    FilterOperation["gt"] = "gt";
    FilterOperation["lt_eq"] = "lt_eq";
    FilterOperation["gt_eq"] = "gt_eq";
    FilterOperation["between"] = "between";
})(FilterOperation || (FilterOperation = {}));
export var OrderOption;
(function (OrderOption) {
    OrderOption["asc"] = "asc";
    OrderOption["desc"] = "desc";
})(OrderOption || (OrderOption = {}));
export var SortDirection;
(function (SortDirection) {
    SortDirection["asc"] = "asc";
    SortDirection["desc"] = "desc";
})(SortDirection || (SortDirection = {}));
